import { render, staticRenderFns } from "./v-alert-local.vue?vue&type=template&id=4152ceb4&scoped=true&"
import script from "./v-alert-local.vue?vue&type=script&lang=js&"
export * from "./v-alert-local.vue?vue&type=script&lang=js&"
import style0 from "./v-alert-local.vue?vue&type=style&index=0&id=4152ceb4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4152ceb4",
  null
  
)

export default component.exports